import React, { useState } from 'react';
import Button from './Button';

const getInitials = (name = '') => name.split(' ').map(w => w[0]).join('').toUpperCase();

const Avatar = ({ person, index, zBase = 10, borderColor = '#1e1b3a', onClick }) => (
  person.image ? (
    <img
      key={index}
      src={person.image}
      alt={person.name}
      title={person.name + ' — Click to view team'}
      onClick={onClick}
      style={{
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        border: `2px solid ${borderColor}`,
        objectFit: 'cover',
        marginLeft: index === 0 ? 0 : '-12px',
        position: 'relative',
        zIndex: zBase + index,
        cursor: 'pointer',
      }}
    />
  ) : (
    <div
      key={index}
      title={person.name + ' — Click to view team'}
      onClick={onClick}
      style={{
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        backgroundColor: borderColor,
        color: '#fff',
        fontSize: '0.7rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `2px solid ${borderColor}`,
        marginLeft: index === 0 ? 0 : '-12px',
        position: 'relative',
        zIndex: zBase + index,
        cursor: 'pointer',
      }}
    >
      {getInitials(person.name)}
    </div>
  )
);

const ResearchDetailCard = ({
  title,
  people = [],
  group,
  advisors = [],
  overview,
  details,
  cost,
  benefits,
  onSponsor,
  orgs = [],
  status = '',
}) => {
  const [showModal, setShowModal] = useState(false);
  const isCompleted = status.toLowerCase() === 'completed';
  const showSponsorship = onSponsor && !isCompleted;

  return (
    <div style={{
      background: '#0F0F1A',
      color: '#ffffff',
      borderRadius: '1rem',
      padding: '2rem',
      maxWidth: '600px',
      margin: '0 auto',
      border: '1px solid rgba(99, 102, 241, 0.3)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      minHeight: '400px',
      position: 'relative',
      overflow: 'hidden',
      gap: '1.5rem',
    }}>
      <div style={{ position: 'absolute', top: '1rem', left: '1rem', display: 'flex', gap: '0.5rem' }}>
        {orgs.map((org, i) => (
          <img
            key={i}
            src={org.image}
            alt={org.name}
            title={org.name}
            style={{
              width: '22px',
              height: '22px',
              borderRadius: '50%',
              border: '1.5px solid #fff',
              objectFit: 'cover',
              backgroundColor: '#ffffff',
            }}
          />
        ))}
      </div>

      <div style={{ marginTop: '2rem' }}>
        <h1 className="title">{title}</h1>
        <p className="big-content-text">{overview}</p>
        <p className="big-content-text">{details}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', marginRight: '1rem', position: 'relative' }}>
          {people.map((person, i) => (
            <Avatar key={`person-${i}`} person={person} index={i} zBase={10} borderColor="#1e1b3a" onClick={() => setShowModal(true)} />
          ))}
        </div>
        <div style={{ display: 'flex', position: 'relative' }}>
          {advisors.map((advisor, i) => (
            <Avatar key={`advisor-${i}`} person={advisor} index={i} zBase={20} borderColor="#4f46e5" onClick={() => setShowModal(true)} />
          ))}
        </div>
      </div>

      <div>
        <img
          src={group}
          alt="Research group photo"
          style={{
            width: '100%',
            maxWidth: '900px',
            objectFit: 'cover',
            display: 'block',
            borderRadius: showSponsorship ? '1rem 1rem 0 0' : '1rem',
            boxSizing: 'border-box',
            border: '.5px solid #333',
          }}
        />

        {showSponsorship && (
          <div style={{
            backgroundColor: 'rgba(255,255,255,0.05)',
            padding: '1rem',
            border: '.5px solid #333',
            borderTop: 'none',
            borderBottomLeftRadius: '1rem',
            borderBottomRightRadius: '1rem',
            marginTop: 0,
          }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
              <Button label="Sponsor Now" to="/contact" />
            </div>
          </div>
        )}
      </div>

      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}>
          <div style={{
            background: '#1e1b3a',
            padding: '1rem',
            borderRadius: '1rem',
            maxWidth: '500px',
            width: '90%',
            maxHeight: '90vh',
            overflowY: 'auto',
            padding: ' .5rem 1rem 1rem 1rem',
          }}>
            <h1 className='title' style={{ fontSize: '1.25rem', marginBottom: '0.75rem' }}>Research Team</h1>
            <h2 className='subtitle' style={{ textAlign: 'left', color: '#ffffff', fontSize: '1rem', marginBottom: '0.5rem' }}>Researchers:</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: advisors.length ? '1rem' : '0' }}>
              {people.map((p, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  {p.linkedin ? (
                    <a
                      href={p.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}
                    >
                      {p.image && (
                        <img
                          src={p.image}
                          alt={p.name}
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            border: '1px solid #a5b4fc',
                          }}
                        />
                      )}
                      <span style={{ fontSize: '0.9rem' }}>{p.name} ↗</span>
                    </a>
                  ) : (
                    <>
                      {p.image && (
                        <img
                          src={p.image}
                          alt={p.name}
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            border: '1px solid #a5b4fc',
                          }}
                        />
                      )}
                      <span style={{ fontSize: '0.9rem' }}>{p.name}</span>
                    </>
                  )}
                </div>
              ))}

            </div>


            {advisors.length > 0 && (
              <>
              <h2 className='subtitle' style={{ textAlign: 'left', color: '#ffffff', fontSize: '1rem', marginBottom: '0.5rem' }}>Advisors:</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
  {advisors.map((a, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {a.linkedin ? (
            <a
              href={a.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}
            >
              {a.image && (
                <img
                  src={a.image}
                  alt={a.name}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '1px solid #c084fc',
                  }}
                />
              )}
              <span style={{ fontSize: '0.9rem' }}>{a.name} ↗</span>
            </a>
          ) : (
            <>
              {a.image && (
                <img
                  src={a.image}
                  alt={a.name}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '1px solid #c084fc',
                  }}
                />
              )}
              <span style={{ fontSize: '0.9rem' }}>{a.name}</span>
            </>
          )}
        </div>
      ))}
</div>


              </>
            )}
            <Button label="Close" onClick={() => setShowModal(false)} style={{ marginTop: '1rem' }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ResearchDetailCard;
